const PropTypes = require('prop-types')
const hasFeature = require('module/user/helpers/has_feature')

// component which renders children if the viewer is anonymous or free
function NotProComponent({ children }, { viewer }) {
    if (hasFeature(viewer, 'upgrade')) return null
    return children
}
NotProComponent.propTypes = {
    children: PropTypes.any,
}
NotProComponent.contextTypes = {
    viewer: PropTypes.object.isRequired,
}

module.exports = {
    NotProComponent,
}
